import React from 'react';

import style from './index.module.scss';

function TopWriters() {
  return (
    <>
      <div className={`row ${style['row--header']}`}>
        <div className={style.image}>
          <img src="/images/top-writers.png" alt="Top Writers"/>
        </div>
        <div className={style.title}>
          <h3>Most Viewed Writers in Geography</h3>
          <p>The 10 writers with the most answer views in the last 30 days.</p>
        </div>
      </div>
      <div className={`row ${style['row--main-list']}`}>
        Writer List
      </div>
    </>
  )
}

export default TopWriters;
